export const txtNombre = /^[a-zA-Z-äëïöüÄËÏÖÜáéíóúÁÉÍÓÚÑñ\s]+$/i;
export const txtOrg = /^[a-zA-Z-äëïöüÄËÏÖÜáéíóúÁÉÍÓÚÑñ\s.,]+$/i;